import React, { useState } from "react";
import Button from "react-bootstrap/Button";
import axios from "axios";
import FormData from "form-data";
const Configuration = () => {
  const [selectedFile, setSelectedFile] = useState(null);
  const apiUrl = "https://codegraff-posters-api.herokuapp.com"; //process.env.API
  const onClickHandler = async () => {
    console.log(selectedFile);
    const data = new FormData();
    data.append("file", selectedFile);
    await axios.post(
      `${apiUrl || "http://localhost:9000"}/content/upload`,
      data
    );
  };

  const fileChangeHandler = (e) => {
    setSelectedFile(e.target.files[0]);
  };

  return (
    <div>
      <input type="file" name="file" onChange={fileChangeHandler} />
      <Button onClick={onClickHandler}>Upload</Button>
    </div>
  );
};

export default Configuration;
